export type { HowTrainingWorksCardType } from './getHowTrainingWorksData'
export { getHowTrainingWorksData } from './getHowTrainingWorksData'
